<template>
  <el-dialog
    title="快速跟进"
    :visible.sync="dialogVisible"
    width="560px"
    :append-to-body="true"
  >
    <div class="crm-follow-form">
      <div v-if="customer" class="crm-follow-tip">
        <span>当前客户：{{ customer.name }}</span>
        <crm-phone-field :phone="customer.phone" status="pending" />
      </div>
      <el-row :gutter="12">
        <el-col :span="12">
          <el-select
            v-model="localForm.method"
            placeholder="跟进方式"
            style="width: 100%"
          >
            <el-option
              v-for="item in options.followMethods"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-select
            v-model="localForm.result"
            placeholder="跟进结果"
            style="width: 100%"
          >
            <el-option
              v-for="item in options.followResults"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="12">
          <el-select
            v-model="localForm.valid"
            placeholder="是否有效跟进"
            style="width: 100%"
          >
            <el-option label="有效跟进" :value="true"></el-option>
            <el-option label="无效跟进" :value="false"></el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-select
            v-model="localForm.hasWeChat"
            placeholder="是否已加微信"
            style="width: 100%"
          >
            <el-option label="已加微信" :value="true"></el-option>
            <el-option label="未加微信" :value="false"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-date-picker
        v-model="localForm.nextFollowTime"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm"
        placeholder="下次跟进时间"
        style="width: 100%"
      ></el-date-picker>
      <el-input
        type="textarea"
        :rows="4"
        v-model="localForm.summary"
        placeholder="沟通摘要，建议填写客户反馈、疑问点和下一步安排"
      ></el-input>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submit">保存跟进</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { CRM_OPTIONS } from "./mock";
import CrmPhoneField from "./PhoneField.vue";

export default {
  name: "CrmFollowDialog",
  components: { CrmPhoneField },
  props: {
    visible: { type: Boolean, default: false },
    customer: { type: Object, default: null },
    value: {
      type: Object,
      default() {
        return {
          method: "电话",
          result: "有效沟通",
          summary: "",
          valid: true,
          hasWeChat: false,
          nextFollowTime: "",
        };
      },
    },
  },
  data() {
    return {
      options: CRM_OPTIONS,
      localForm: { ...this.value },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.localForm = { ...value };
      },
    },
    visible(value) {
      if (value) {
        this.localForm = { ...this.value };
      }
    },
  },
  methods: {
    submit() {
      if (!this.localForm.summary || this.localForm.summary.length < 10) {
        this.$message.warning("请补充更完整的沟通摘要");
        return;
      }
      this.$emit("submit", { ...this.localForm });
    },
  },
};
</script>

<style scoped>
.crm-follow-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.crm-follow-tip {
  border-radius: 12px;
  background: #f8fbff;
  border: 1px dashed #d7e6fb;
  padding: 12px 14px;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
